import { useState } from "react";
import Footer from "../layout/footer/Footer";
import styles from "./AnonClaim.module.css";
import CompanyInquiry from "./claim-components/CompanyInquiry/CompanyInquiry";
import FoundersMessage from "./claim-components/FoundersMessage/FoundersMessage";
import ClaimFrame from "./claim-components/ClaimFrame";
import { uticaCompany, foundersCompany, unknownCompany } from "../../constants/data";

function NewAnonymousClaim() {
  const [uwCompany, setUwCompany] = useState(unknownCompany);

  function loadInner() {
    switch (uwCompany) {
      case unknownCompany:
        return <CompanyInquiry setUwCompany={setUwCompany} />;
      case uticaCompany:
        return <ClaimFrame />;
      case foundersCompany:
        return <FoundersMessage setUwCompany={setUwCompany}  />;
      default: 
        return unknownCompany;
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.claimToFileDiv}>
        {loadInner()}
        <div className={styles.footerContainer}>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default NewAnonymousClaim;
